import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseMailboxesFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2.5C1 1.67157 1.67157 1 2.5 1H13.5C14.3284 1 15 1.67157 15 2.5V6.75H10C8.20507 6.75 6.75 8.20507 6.75 10V16.5H2.5C1.67157 16.5 1 15.8284 1 15V2.5ZM13 2.75L3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25L13 4.25C13.4142 4.25 13.75 3.91421 13.75 3.5C13.75 3.08579 13.4142 2.75 13 2.75ZM10 8.5C9.17157 8.5 8.5 9.17157 8.5 10V21.5C8.5 22.3284 9.17157 23 10 23H20.5C21.3284 23 22 22.3284 22 21.5V10C22 9.17157 21.3284 8.5 20.5 8.5H10ZM20 10.25H10.5C10.0858 10.25 9.75 10.5858 9.75 11C9.75 11.4142 10.0858 11.75 10.5 11.75L20 11.75C20.4142 11.75 20.75 11.4142 20.75 11C20.75 10.5858 20.4142 10.25 20 10.25ZM15.25 15.75C15.9404 15.75 16.5 15.1904 16.5 14.5C16.5 13.8096 15.9404 13.25 15.25 13.25C14.5596 13.25 14 13.8096 14 14.5C14 15.1904 14.5596 15.75 15.25 15.75Z"
        fill={color}
      />
    </svg>
  );
};
